export interface IPropertyPhotos {
    taskDetails: {
        Id: string;
        ProjectId: string;
    };
}

export interface ImageWithMetadata {
    url: string;
    assetId?: string;
    note?: string | null;
}

export const roofingPhotoSections = [
    {
        id: "frontHouse",
        title: "Front of House",
        label: "TASK:INITIAL_INSPECTION:FHSA",
        description: "Capture a wide shot showing the address and the overall front view of the property.",
        coverImage: "https://frontgate.scene7.com/is/image/frontgate/b-75716_main?$wfih$",
    },
    {
        id: "slopeOverview",
        title: "Slope Overview",
        label: "TASK:INITIAL_INSPECTION:OOES",
        description: "Photos showing the condition and angles of each slope of the roof.",
        coverImage: "https://th.bing.com/th/id/OIP.FXGnl5iVTRl628OV_sHtBgHaEK?rs=1&pid=ImgDetMain",
    },
    {
        id: "penetrationCloseups",
        title: "Penetration Close-ups",
        label: "TASK:INITIAL_INSPECTION:COEP",
        description: "Close-up shots of all roof penetrations, including vents, pipes, and other elements.",
        coverImage: "https://th.bing.com/th/id/OIP.YQiiGgOu67qKRXIaoujb7wHaE8?rs=1&pid=ImgDetMain",
    },
    {
        id: "metalFlashings",
        title: "Metal Flashings",
        label: "TASK:INITIAL_INSPECTION:AMFL",
        description: "Images of all metal flashings used, including drip edge, step flashings, and more.",
        coverImage: "https://th.bing.com/th/id/OIP.PE6VypBM2vaWUv4Hg9LJNAHaEK?rs=1&pid=ImgDetMain",
    },
    {
        id: "ridgeCapNails",
        title: "Ridge Cap Nails",
        label: "TASK:INITIAL_INSPECTION:RCNS",
        description: "Detailed photos showing the ridge cap nails and their proper sealing.",
        coverImage:
            "https://encompasshomeinspectionservice.com/wp-content/uploads/2023/05/roof-repairs-maintenance.jpg",
    },
];
